// extracted by mini-css-extract-plugin
export default {"colorMain1":"#6d64c6","colorMain2":"#453ca2","button":"styles_button__9WFlF"};